export const matchCueById = (currentCue: VTTCue) => (cue: VTTCue) => cue.id === currentCue.id;

export const scrollToCue = (firstActiveCue: HTMLDivElement, container: HTMLDivElement) => {
  if (firstActiveCue && container) {
    const top = firstActiveCue.offsetTop;
    const topOffsetThreshold = container.scrollTop;
    const bottomOffsetThreshold = container.offsetHeight + container.scrollTop;

    if (top > bottomOffsetThreshold || top < topOffsetThreshold) {
      container.scroll({ top, behavior: 'smooth' });
    }
  }
};
